import {
  BLOCKS_VIEW_NODE_PAD,
  INVALID_RECTANGLE_SIDES,
  BLOCKS_VIEW_HEADER_INNER_HEIGHT,
  BLOCKS_VIEW_EXPANDER_MARGIN_RIGHT,
  BLOCKS_VIEW_URL_ICON_MARGIN_LEFT,
} from '../../consts';
import { BlocksViewNode } from '../../types';
import { descendantCountBadgeRect } from './descendantCountBadgeRect';
import { rectWidth } from '../../misc/geometry';
import { urlIconRect } from './urlIconRect';

type BottomlessRectangleSides = [
  left: number,
  top: number,
  right: number,
  bottom: typeof Infinity,
];
/**
 * @returns a bottomless rectangle where the label should be oriented.
 * @todo not yet implemented for leaf nodes or collapsed component groups.
 */
const labelRect = (
  node: BlocksViewNode,
  cell = node.cell
): BottomlessRectangleSides => {
  const { children, open, urlFieldValues, isComponent } = node;
  const isGroup = children?.length;
  if (!cell || !isGroup) {
    return INVALID_RECTANGLE_SIDES;
  }
  const [left, top, right] = cell;
  const expanderWidth =
    BLOCKS_VIEW_NODE_PAD +
    BLOCKS_VIEW_HEADER_INNER_HEIGHT +
    BLOCKS_VIEW_EXPANDER_MARGIN_RIGHT;
  if (isComponent && !open) {
    return INVALID_RECTANGLE_SIDES;
  }
  const representationWidth = isComponent
    ? BLOCKS_VIEW_HEADER_INNER_HEIGHT + BLOCKS_VIEW_NODE_PAD
    : 0;
  const descendantCountBadgeWidth = open
    ? 0
    : rectWidth(descendantCountBadgeRect(node)) + BLOCKS_VIEW_NODE_PAD;
  const urlIconWidth =
    open && urlFieldValues?.length
      ? rectWidth(urlIconRect(node)) + BLOCKS_VIEW_URL_ICON_MARGIN_LEFT
      : 0;
  const leftWidth = expanderWidth + representationWidth;
  const rightWidth =
    BLOCKS_VIEW_NODE_PAD + descendantCountBadgeWidth + urlIconWidth;
  return [
    left + leftWidth,
    top + BLOCKS_VIEW_NODE_PAD,
    right - rightWidth,
    Infinity,
  ];
};

export { labelRect };
